<template>
  <div class="section-title" :class="{'decorated': decorated}">
    <h3 v-if="!houseNotes"><slot name="title" /></h3>
    <house-notes-logo v-if="houseNotes" element="h2" />
    <slot name="link" />
  </div>
</template>

<script>
import HouseNotesLogo from '~/components/house-notes-logo'

export default {
  components: {
    HouseNotesLogo
  },
  props: {
    decorated: {
      type: Boolean,
      required: false,
      default: false
    },
    houseNotes: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

.section-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: $d-small;

  &.decorated {
    text-align: center;
    display: block;
    padding: $d-small 0;
  }

  .house-notes-logo {
    width: 222px;
    height: 100%;
  }

  h3 {
    @include font('080');
    font-weight: normal;

    @include tablet {
      @include font('080');
    }
  }

  button {
    @include label-x-sml;
  }

  a {
    @include font('050');
  }

  a, button {
    text-decoration: none;
    @include deprecated-f-color-highlight;
    padding: 0;
    width: auto;
  }
}

</style>
